<template>
    <div class="sfc-student-loan-calc">
        <div class="container-fluid wave">
            <div class="sfc-container">
				<h5>Looking to lower your payments?</h5>
				<h1>Student Loan Refinance Calculator</h1>
				<!--Schema Markup FAQs-->
				<script v-html="create_schema(FAQList)" type="application/ld+json"/>
				<p>
					This student loan refinancing calculator estimates the monthly and total savings possible by refinancing your student loans. You can also compare different loan terms and interest rates to find the right refinance loan for you. See the list of refinancing lenders below the calculator to see their current interest rate ranges. Remember, your interest rate will be determined by your credit profile and length of loan term, with higher terms carrying a higher interest rate.
				</p>
				<div class="sfc-card">
					<div id="res" v-if="resultDisplayed"  class="sfc-row results content block">
                        <div class="sfc-row" style="padding-bottom: 15px;">
                            <h4 class="w-100">Your Loan Refinancing Calculator Results
								<div class="social-media-area-floated">
									<sfc-share-component :hero="`https://web-resources.savingforcollege.com/images/cost-of-deferment-calculator-thumbnail.jpg`" title="Student Loan Refinance Calculator" :url="`${this.$store.state.config.sfcHost}/calculators/student-loan-refinance-calculator`" ></sfc-share-component>
								</div>

							</h4>
                        </div>
                        <div class="sfc-row">
							<div class="sfc-col-6">
								<table class="list flex income-driven-results white-bg">
									<tbody>
										<tr class="table-header">
											<td>Before Refinancing</td>
											<td> </td>
											<td> </td>
										</tr>
										<tr class="list-row">
											<!-- <td class="gray-text">Total Payment</td> -->
											<td class="dark-text">Total Payment:
												<strong>
												{{formatNumber(currentLoanResult.totalPayments.toFixed(2))}}
												</strong>
											</td>
											<td class="dark-text">Number of Payments:
												<strong>
													{{currentLoanResult.numberOfPayments}}
													 <!-- ({{makeDurationString(currentLoanResult.numberOfPayments)}}) -->
												</strong>
											</td>
											<td class="dark-text">Monthly Payment
												<strong>
													{{formatNumber(currentLoanResult.monthlyPayment.toFixed(2))}}
												</strong>
											</td>
										</tr>

										<tr class="table-header">
											<td>After Refinancing</td>
											<td> </td>
											<td> </td>
										</tr>
										<tr class="list-row">
											<!-- <td class="gray-text">Total Payment</td> -->
											<td class="dark-text">
												<span>Total Payment:</span>
												<strong class="after-repayment-total">
													{{formatNumber(newLoanResult.totalPayments.toFixed(2))}}
												</strong>
											</td>
											<td class="dark-text">Number of Payments:
												<strong>
													{{newLoanResult.numberOfPayments}}
													<!-- ({{makeDurationString(newLoanResult.numberOfPayments)}}) -->
												</strong>
											</td>
											<td class="dark-text">Monthly Payment
												<strong>
													{{formatNumber(newLoanResult.monthlyPayment.toFixed(2))}}
												</strong>
											</td>

										</tr>

									</tbody>
								</table>
							</div>
							<div class="sfc-col-6">
								<div class="bluebg content text-center blue-box">
									<!-- <h2>Your Results</h2> -->
									<p>Change To Your Total Payment</p>
									<h3 class="largeText largerText">
										{{formatNumber(output.total_saving)}}
										<p class="subText">{{makePercentString(output.totalPercent)}}</p>
									</h3>

									<h2></h2>
									<p>Number Of Payments</p>
									<h3 class="largeText mediumText">
										{{output.new_number_of_payments}}
										<p class="subText">({{makeDurationString(output.new_number_of_payments)}})</p>
									</h3>
									<h2></h2>
									<p>Change To Your Monthly Payment</p>
									<h3 class="largeText mediumText">
										{{formatNumber(output.monthly_saving)}}
										<p class="subText">{{makePercentString(output.monthlyPercent)}}</p>
									</h3>
								</div>
							</div>
                     	</div>
						 <div class="content mobile-and-tablet">
							<div class="sfc-col-12">
								<h4 class="cardTitle ml-0 pl-0">Next Steps:</h4>
								<ul>
									<li>Learn about the <a href="/article/whats-the-difference-between-student-loan-consolidation-and-refinance">difference between student loan refinance and consolidation</a>.</li>
									<li class="mt-3">Consider the <a href="/article/pros-and-cons-of-student-loan-refinancing">pros and cons of student loan refinancing</a>.</li>
								</ul>
							</div>
						</div>
						<div class="student-loan-widget-v1-inside" v-show="resultDisplayed" >
							<script defer src='https://sfc-external-widgets.savingforcollege.com/student_loan_widget_v2/production/loaders/loader.js?loan_type=originator&audience=refinance'></script>
						</div>
					</div>

					<!--div v-show="resultDisplayed" class="ad-refinancecalc-inside no-mobile">
						<sfc-dfp-ad ad-unit="savingforcollege_refinancecalc_leaderboard" sizes="[[728, 90]]" :responsive="true">
						</sfc-dfp-ad>
					</div>
					<div v-show="resultDisplayed" class="ad-refinancecalc-inside mobile-and-tablet">
						<sfc-dfp-ad ad-unit="savingforcollege_refinancecalc_mobile_tilE_1" sizes="[[300, 250]]" :responsive="true">
						</sfc-dfp-ad>
					</div-->
					<form @submit.prevent="recalculate" class="form sfc-col-12">
						<h4 class="cardTitle">Loan Comparison
							<div v-if="!resultDisplayed" class="social-media-area-floated">
								<sfc-share-component :hero="`https://web-resources.savingforcollege.com/images/cost-of-deferment-calculator-thumbnail.jpg`" title="Student Loan Refinance Calculator" :url="`${this.$store.state.config.sfcHost}/calculators/student-loan-refinance-calculator`" ></sfc-share-component>
							</div>
						</h4>
						<div class="sfc-row flex content">
							<div class="sfc-col-6">
								<div class="input-group">
									<label for="loan-balance" class="label"
										>Current Loan Balance</label
									><br />
									<div class="inner">
										<input
											placeholder=""
                                            class="input postend"
                                            type="number"
                                            min="100"
										    max="10000000000‬"
											step="1"
                                            v-model="input.loan_amount"
                                            name="loan-balance"
                                            id="loan-balance"
                                            required
										/>
										<span class="end">$</span>
										<div class="tooltip">
											<img
												:src="`${$store.state.config.s3ResourceHost}/images/student-loans/info@2x.svg`"
												alt="info icon vector"
												class="info"
											/>
											<span class="tooltiptext"
												>The total amount you owe as of today. An estimate is just fine!</span
											>
										</div>
									</div>
								</div>
								<div class="input-group">
									<label for="current-interest" class="label"
										>Current Interest Rate</label
									><br />
									<div class="inner">
										<input
											placeholder=""
                                            class="input postend"
                                            type="number"
                                            min="0.1"
                                            max="100"
                                            step="any"
                                            v-model="input.current_interest_rate"
                                            name="current-interest"
                                            id="current-interest"
                                            required
										/>
										<span class="end">%</span>
										<div class="tooltip">
											<img
												:src="`${$store.state.config.s3ResourceHost}/images/student-loans/info@2x.svg`"
												alt="info icon vector"
												class="info"
											/>
											<span class="tooltiptext"
												>The <a href="/article/how-student-loan-interest-works" target="_blank">interest rate</a> you are currently paying, or the average interest rate across the multiple loans you have. Not sure what that is? Try a standard 5% for starters and play what-if games with different rates.</span
											>
										</div>
									</div>
								</div>
								<div class="input-group">
									<label for="loan-term" class="label"
										>Loan Term</label
									><br />
									<div class="inner">
										<input
											placeholder=""
                                            class="input postend"
                                            type="number"
                                            min="1"
                                            max="600"
                                            step="1"
                                            v-model="input.current_loan_term"
                                            name="loan-term"
                                            id="loan-term"
                                            required
										/>
										<span class="end">YEARS</span>
										<div class="tooltip">
											<img
												:src="`${$store.state.config.s3ResourceHost}/images/student-loans/info@2x.svg`"
												alt="info icon vector"
												class="info"
											/>
											<span class="tooltiptext"
												>The number of years you have left to <a href="/article/how-long-does-it-take-to-repay-a-student-loan" target="_blank">pay off what you borrowed</a>. If you started with a 10 year repayment term 3 years ago, this number would be 7.</span
											>
										</div>
									</div>
								</div>
							</div>
							<div class="sfc-col-6">
								<div class="input-group">
									<label for="avg-interest" class="label"
										>New Interest Rate</label
									><br />
									<div class="inner">
										<input
											placeholder=""
                                            class="input postend"
                                            type="number"
                                            min="0.1"
                                            step="any"
                                            max="100"
                                            v-model="input.new_interest_rate"
                                            name="avg-interest"
                                            id="avg-interest"
                                            required
										/>
										<span class="end">%</span>
										<div class="tooltip">
											<img
												:src="`${$store.state.config.s3ResourceHost}/images/student-loans/info@2x.svg`"
												alt="info icon vector"
												class="info"
											/>
											<!-- <span class="tooltiptext"
												>The interest rate on the loan you are considering. The exact rate you end up getting depends on the lender’s review of your credit history. For the range of interest rates top lenders offer, check out this <a href="/best-private-student-loans-for-college" targe="_blank">list</a> and plug in different numbers.</span
											> -->
											<span class="tooltiptext"
												>The interest rate on the loan you are considering. The exact rate you end up getting depends on the lender's review of your credit history.</span
											>
										</div>
									</div>
								</div>
								<div class="input-group">
									<label for="new-loan-term" class="label"
										>New Loan Term</label
									><br />
									<div class="inner">
										<input
											placeholder=""
                                            class="input postend"
                                            type="number"
                                            min="1"
                                            max="50"
                                            step="1"
                                            v-model="input.new_loan_term"
                                            name="loan-term"
                                            id="loan-term"
                                            required
										/>
										<span class="end">YEARS</span>
										<div class="tooltip">
											<img
												:src="`${$store.state.config.s3ResourceHost}/images/student-loans/info@2x.svg`"
												alt="info icon vector"
												class="info"
											/>
											<span class="tooltiptext"
												>The number of years you will have to pay off the loan you are considering. Standard repayment is 10 years.</span
											>
										</div>
									</div>
								</div>
								<button class="btn btn-primary">
									Calculate
								</button>
							</div>
						</div>
					</form>
					<!-- <div id="res" v-if="resultDisplayed" class="sfc-row results bluebg text-center">
						<div class="sfc-row content block">
							<h4>Your Results</h4>
							<div class="sfc-row">
								<div class="sfc-col-4">
									<p>Change to your total payment</p>
									<h3 class="largeText">{{formatNumber(output.total_saving)}}</h3>
									<p class="subText">{{makePercentString(output.totalPercent)}}</p>
								</div>
								<div class="sfc-col-4">
									<p>Number of Payments</p>
									<h3 class="largeText">{{output.new_number_of_payments}}</h3>
									<p class="subText">({{makeDurationString(output.new_number_of_payments)}})</p>
								</div>
								<div class="sfc-col-4">
									<p>Change to your monthly payment</p>
									<h3 class="largeText">{{formatNumber(output.monthly_saving)}}</h3>
									<p class="subText">{{makePercentString(output.monthlyPercent)}}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="sfc-row results text-center" id="res" v-if="resultDisplayed">
						<table class="list content flex">
							<tbody class="sfc-col-12">
								<tr class="table-header">
									<td></td>
									<td>Total Payment</td>
									<td>Number of Payments</td>
									<td>Monthly Payment</td>
								</tr>
								<tr class="list-row">
									<td>Before Refinancing</td>

									<td>{{formatNumber(currentLoanResult.totalPayments.toFixed(2))}}</td>
									<td>{{currentLoanResult.numberOfPayments}} ({{makeDurationString(currentLoanResult.numberOfPayments)}})</td>
									<td class="large">{{formatNumber(currentLoanResult.monthlyPayment.toFixed(2))}}</td>
								</tr>
								<tr class="list-row">
									<td>After Refinancing</td>

									<td>{{formatNumber(newLoanResult.totalPayments.toFixed(2))}}</td>
									<td>{{newLoanResult.numberOfPayments}} ({{makeDurationString(newLoanResult.numberOfPayments)}})</td>
									<td class="large">{{formatNumber(newLoanResult.monthlyPayment.toFixed(2))}}</td>
								</tr>
							</tbody>
						</table>
					</div> -->
					<!-- <div class="sfc-row graybg">
						<div class="sfc-col-6 content">
							<p class="dark-text">
								Think you’re paying too much each month?
							</p>
							<p class="medium gray-text">
								Refinancing your student loans could change that.
							</p>
						</div>
						<div class="sfc-col-6 content">
							<button class="btn btn-secondary btn-medium">
								Find My Rate
							</button>
						</div>
					</div> -->
				</div>
			</div>
        </div>
		<div v-show="!resultDisplayed" class="no-mobile">
			<div class="student-loan-widget-v1">
				<script defer src='https://sfc-external-widgets.savingforcollege.com/student_loan_widget_v2/production/loaders/loader.js?loan_type=originator&audience=refinance'></script>
			</div>
			<!--sfc-dfp-ad ad-unit="savingforcollege_refinancecalc_leaderboard" sizes="[[728, 90]]" :responsive="true">
			</sfc-dfp-ad-->
		</div>
		<div v-show="!resultDisplayed" class="mobile-and-tablet">
			<div class="student-loan-widget-v1">
				<script defer src='https://sfc-external-widgets.savingforcollege.com/student_loan_widget_v2/production/loaders/loader.js?loan_type=originator&audience=refinance'></script>
			</div>
			<!--sfc-dfp-ad ad-unit="savingforcollege_refinancecalc_mobile_tile_1" sizes="[[300, 250]]" :responsive="true">
			</sfc-dfp-ad-->
		</div>
		  <!-- Site footer -->
		<footer class="site-footer" v-if="!blankLayout">
			<div style="margin:0px auto!important;padding:0px 15px;">
				<div class="row">
					<div class="col-sm-10 offset-sm-1 col-lg-6 offset-lg-1 col-xl-5 offset-xl-2 content">
						<h6 class="footer_title">FAQs about loan refinancing calculator</h6>
						<div class="accordion" v-for="index in FAQList" :key="index.id">
							<div>
								<input type="radio" @click="toggleAccordion(index.id)" name="example_accordion" :id="index.id" class="student-loan-radio accordion__input">
								<label :for="index.id" class="accordion__label">{{ index.question }}</label>
								<div class="accordion__content">
								    <p v-html="index.answer"></p>
								</div>
							</div>
						</div>
						<div class="related-content">
							<h6 class="footer_title">Related Content</h6>
							<article class="card_related">
								<div class="card__left">
									<div class="card__image">
										<img :src="`https://webresources-savingforcollege.s3.us-west-2.amazonaws.com/images/articles/facebook_20200302114922_refi_fb.jpeg`" alt="Pros and Cons of Student Loan Refinancing"/>
									</div>
								</div>
								<div class="card__right">
									<p class="card__info">
										<a href="https://www.savingforcollege.com/article/pros-and-cons-of-student-loan-refinancing" target="_blank">Pros and Cons of Student Loan Refinancing</a>
									</p>
									<p class="card__detail">
										{{ `Refinancing student loan debt means you essentially trade your current student loans for a brand new loan. People refinance student loans to get a lower interest rate, which helps save money and pay off your student loan debt faster. However, student loan refinancing isn’t for everyone and there are pros and cons of refinancing student loans. Here are some of the benefits and drawbacks of student loan refinancing.` | capText}}
									</p>
								</div>
							</article>

							<article class="card_related">
								<div class="card__left">
									<div class="card__image">
										<img :src="`https://webresources-savingforcollege.s3.us-west-2.amazonaws.com/images/articles/facebook_20191230124118_refinance_fb.jpeg`" alt="Requirements for Student Loan Refinancing" />
									</div>
								</div>
								<div class="card__right">
									<p class="card__info">
										<a href="https://www.savingforcollege.com/article/requirements-for-student-loan-refinancing" target="_blank">Requirements for Student Loan Refinancing</a>
									</p>
									<p class="card__detail">
										{{ `Student loan refinancing is an appealing option for many borrowers. It gives you more control over repayments, allowing you to lower your interest rate, reduce your monthly payment and pay off student loans quicker. To qualify for student loan refinancing, most lenders have some specific requirements, including the following.` | capText}}
									</p>
								</div>
							</article>

							<article class="card_related">
								<div class="card__left">
									<div class="card__image">
										<img :src="`https://webresources-savingforcollege.s3.us-west-2.amazonaws.com/images/articles/facebook_20200121095550_sittingbycomputer_fb.jpeg`" alt="Student Loan Refinancing FAQs"/>
									</div>
								</div>
								<div class="card__right">
									<p class="card__info">
										<a href="https://www.savingforcollege.com/article/student-loan-refinancing-faqs" target="_blank">Student Loan Refinancing FAQs</a>
									</p>
									<p class="card__detail">
										{{ `Refinancing student loans could potentially lower your interest rate, saving you money. But there are also drawbacks to refinancing student loans. Here are the most common questions asked about refinancing student loans.` | capText}}
									</p>
								</div>
							</article>
						</div>
					</div>
					<div class="ad-refinancecalc mobile-and-tablet">
						<sfc-dfp-ad ad-unit="savingforcollege_refinancecalc_mobile_tilE_2" sizes="[[300, 250]]" :responsive="true">
						</sfc-dfp-ad>
					</div>
					<more-calculators></more-calculators>
				</div>
				<div class="row">
					<!--
					<div class="col-sm-10 offset-sm-1 col-lg-6 offset-lg-1 col-xl-5 offset-xl-2 content">
						<h6 class="footer_title">Related Content</h6>
						<article class="card_related">
							<div class="card__left">
								<div class="card__image">
									<img :src="`https://webresources-savingforcollege.s3.us-west-2.amazonaws.com/images/articles/facebook_20200302114922_refi_fb.jpeg`"/>
								</div>
							</div>
							<div class="card__right">
								<p class="card__info">
									<a href="https://www.savingforcollege.com/article/pros-and-cons-of-student-loan-refinancing" target="_blank">Pros and Cons of Student Loan Refinancing</a>
								</p>
								<p class="card__detail">
									{{ `Refinancing student loan debt means you essentially trade your current student loans for a brand new loan. People refinance student loans to get a lower interest rate, which helps save money and pay off your student loan debt faster. However, student loan refinancing isn’t for everyone and there are pros and cons of refinancing student loans. Here are some of the benefits and drawbacks of student loan refinancing.` | capText}}
								</p>
							</div>
						</article>

						<article class="card_related">
							<div class="card__left">
								<div class="card__image">
									<img :src="`https://webresources-savingforcollege.s3.us-west-2.amazonaws.com/images/articles/facebook_20191230124118_refinance_fb.jpeg`" />
								</div>
							</div>
							<div class="card__right">
								<p class="card__info">
									<a href="https://www.savingforcollege.com/article/requirements-for-student-loan-refinancing" target="_blank">Requirements for Student Loan Refinancing</a>
								</p>
								<p class="card__detail">
									{{ `Student loan refinancing is an appealing option for many borrowers. It gives you more control over repayments, allowing you to lower your interest rate, reduce your monthly payment and pay off student loans quicker. To qualify for student loan refinancing, most lenders have some specific requirements, including the following.` | capText}}
								</p>
							</div>
						</article>

						<article class="card_related">
							<div class="card__left">
								<div class="card__image">
									<img :src="`https://webresources-savingforcollege.s3.us-west-2.amazonaws.com/images/articles/facebook_20200121095550_sittingbycomputer_fb.jpeg`" />
								</div>
							</div>
							<div class="card__right">
								<p class="card__info">
									<a href="https://www.savingforcollege.com/article/student-loan-refinancing-faqs" target="_blank">Student Loan Refinancing FAQs</a>
								</p>
								<p class="card__detail">
									{{ `Refinancing student loans could potentially lower your interest rate, saving you money. But there are also drawbacks to refinancing student loans. Here are the most common questions asked about refinancing student loans.` | capText}}
								</p>
							</div>
						</article>
					</div>-->
				</div>
			</div>
		</footer>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { LoanCalculator } from 'sfc_calcs_js'
import Vue from 'vue'
import VueFilterDateFormat from 'vue-filter-date-format'
import sfcShareComponent from '@/common/components/share-component'
import MoreCalculators from '@/common/components/calculators/more-calculators'

Vue.use(VueFilterDateFormat)
export default {
	layout: 'default_student_loan',
	components: {
		sfcShareComponent,
		MoreCalculators
	},
    data(){
		let blankLayout = false
		if(this.$route.query.layout && this.$route.query.layout == "blank"){
			blankLayout = true
		}

		return {
			blankLayout,
			input: {
				loan_amount: null,
				loanFees: 1.059,
                current_interest_rate: null,
				new_interest_rate: null,
                current_loan_term: null,
				new_loan_term: null,
				minMonthlyPayment: 50
            },
            output: {
				new_number_of_payments: 0.00,
				monthly_saving: 0.00,
				total_saving: 0.00,
				monthlyPercent:0.00,
				totalPercent:0.00,
			},
			resultDisplayed:false,
			durationString:"",
			FAQList:[
                {id: 1,
                question: "What does it mean to refinance student loans?",
                answer: "Refinancing student loans means that you trade your current student loan debt for an entirely new private student loan. The new loan pays off the old loans. Refinancing your student loans might provide a lower interest rate, which saves you money and could eliminate your debt sooner. Refinancing yields a completely new lender. You need to apply and be approved just like any other loan. The terms of your new loan and any perks from federal student loans will not apply to this new loan."},
                {id: 2,
                question: "What’s the difference between consolidating and refinancing student loans?",
                answer: "The difference between student loan consolidation and a refinance depends on how the interest rate is determined. You can consolidate most federal loans, which combines multiple loans into one payment. Consolidating loans does not give you a lower interest rate like refinancing potentially can. If you consolidate your student loans, your interest rate is based on the weighted average of your current interest rates. If you consolidate federal student loans into a federal consolidation loan, you can still have most federal student loan benefits, unlike refinancing to a private lender. Refinancing your student loans also combines your loans into a single loan, but the interest rate is based on your current credit score and not the current interest rates on your loans."},
                {id: 3,
                question: "What do I need to qualify for refinancing?",
                answer: "Eligibility requirements for refinancing student loans depend on the lender. In many cases, lenders want to see a debt-to-income ratio under 50%, a minimum credit score of 650, steady income, a minimum loan amount to refinance (usually $5,000), loans that aren’t in default, and degree completion. Once you’re ready to apply, you’ll need your loan information ready to complete the process."},
                {id: 4,
                question: "What are the benefits of student loan refinancing?",
                answer: "Refinancing a student loan can lower your interest rate, which reduces the amount of total interest you will pay over the life of the loan. Lowering the interest rate also means that more of your payments are applied to your principal student loan balance, paying off your loan faster. If you choose to have a longer payment term, it could lower your new monthly payment. Combining multiple loans into one new one means it’s easier to keep track of your loan, make payments, and reduce the chance of late payments. Many private lenders offer optional perks, including skipping a payment, choosing your due date, and pausing payments. Other benefits of refinancing include releasing a cosigner from responsibility of your loan and getting a new loan servicer if you’re dissatisfied with your current one."},
                {id: 5,
                question: "What are the drawbacks of student loan refinancing?",
                answer: "If you’re a new graduate, you may lose your grace period (unless you refinance with SoFi or Earnest, which honor your grace period). If you refinance federal student loans into private student loans, you will lose many federal benefits. These include the possibility for student loan forgiveness, enrolling in an income-driven repayment plan and more generous deferment options in times of unemployment and economic hardship."},
                {id: 6,
                question: "Should I refinance my student loans?",
                answer: "Refinancing student loans offers many pros and cons. Before you decide to refinance, really take time to understand your current loans. Are they private, federal, or a mix? If you have federal loans, will you likely take advantage of student loan forgiveness or an income-driven repayment plan? If yes, then refinancing isn’t right for you. If you have private student loans and want to lower your interest rate, it is worth exploring further. Consider both your potential monthly savings and savings over the life of your loans to decide if refinancing is worth it."},
                {id: 7,
                question: "Should I refinance federal student loans?",
                answer: "Refinancing federal student loans means you will lose the perks that come along with federal loans. These include the option for income-driven repayment plans, the possibility of student loan forgiveness and the opportunity for more generous deferment options in times of unemployment and economic hardship. "},
                {id: 8,
                question: "How do I choose a lender to refinance with?",
                answer: "When choosing a lender, consider the interest rate and repayment term they offer you. When researching a lender, there are many other questions to ask. Are there any origination, late payment, or prepayment fees? Do they offer variable interest rates or fixed interest rates that are better than your current student loan rates? How do your potential new payment amounts compare to your existing payments? Do they offer protections like forbearance or deferment options if you have trouble making student loan payments? If you’re applying with a cosigner, do they offer a cosigner release? Are there any other perks that come along with it, such as choosing your payment day or skipping a payment? Is there an autopay discount?"},
				{id: 9,
                question: "Can I use a cosigner for refinancing student loans?",
                answer: "Yes, you can use a cosigner when applying to refinance your student loans. If you don’t have a great credit report or are lacking in another area, a cosigner can help you get approved. Even if you have solid credit, having a cosigner with good credit could mean an even lower interest rate. Keep in mind, as with any other loan, your cosigner is completely responsible for repaying this loan as well."},
            	{id: 10,
                question: "Can I refinance multiple times?",
                answer: "Yes, you can refi your loan multiple times to get a lower interest rate. Some lenders, such as Earnest, even allow you to refinance while you’re still in school."}
			]
		}
    },
    mounted() {
		document.body.className = 'gray';
		setTimeout(() => {
			document.getElementById("sfc-main-content").classList.add("student-loan-calculator-content");
		}, 1000)
	},
	methods: {
		recalculate($event){

			let currentLoan = new LoanCalculator({
				loanBalance: this.input.loan_amount,
				annualInterestRate: this.input.current_interest_rate/100.0,
				repaymentTermInYears: this.input.current_loan_term,
				fees: this.input.loanFees/100.0,
				minimumPayment: this.input.minMonthlyPayment
            });
            let newLoan = new LoanCalculator({
				loanBalance: this.input.loan_amount,
				annualInterestRate: this.input.new_interest_rate/100.0,
				repaymentTermInYears: this.input.new_loan_term,
				fees: this.input.loanFees/100.0,
				minimumPayment: this.input.minMonthlyPayment
			})

            this.currentLoanResult = currentLoan.calculate().output;
			this.newLoanResult = newLoan.calculate().output;


			this.output.new_number_of_payments = this.newLoanResult.numberOfPayments;
            this.output.total_saving = ((this.currentLoanResult.totalPayments - this.newLoanResult.totalPayments)* (-1)).toFixed(2) ;
			this.output.monthly_saving = ((this.currentLoanResult.monthlyPayment - this.newLoanResult.monthlyPayment) * (-1)).toFixed(2);
			this.output.monthlyPercent = ((this.output.monthly_saving/this.currentLoanResult.monthlyPayment)*100);
			this.output.totalPercent = ((this.output.total_saving/this.currentLoanResult.totalPayments)*100);
			this.resultDisplayed = true;

			setTimeout(() => {
				VueScrollTo.scrollTo('#res');
			}, 200)
			$event.preventDefault();
		},
		makeDurationString(numberOfPayments)
		{
			let numberOfYears = Math.trunc(numberOfPayments/12);
			let numberOfMonths = numberOfPayments%12;

			let durationString="";
			if(numberOfYears==1)
				durationString += numberOfYears + " year";
			else if(numberOfYears>1)
				durationString += numberOfYears + " years";

			if(numberOfYears>0 && numberOfMonths>0)
				durationString += " ";

			if(numberOfMonths==1)
				durationString += numberOfMonths + " month";
			else if(numberOfMonths>1)
				durationString += numberOfMonths + " months";

			return durationString;
		},
		makePercentString(valuePercent)
		{
			if(valuePercent<0)
				return "("+parseFloat(valuePercent*(-1)).toFixed(2)+"% decrease)"
			else if(valuePercent>0)
				return "("+parseFloat(valuePercent).toFixed(2)+"% increase)";
			else
				return "";

		},
		formatNumber(number)
		{

			let parsedNumber = Math.abs(number)
			parsedNumber = Number(parsedNumber).toLocaleString();

			let string = parsedNumber.split('.');
			if(string[1]!=undefined) {
				string = string[1];

				if(string.length==1){
					parsedNumber+="0";
				}
			} else {
				parsedNumber+=".00";
			}

			if (number < 0) {
				return `-$${parsedNumber}`
			}
			return `$${parsedNumber}`
		},
		toggleAccordion(section){
			if (this.lastSectionOpened == section) {
				let input = document.getElementById(section)
				if (input.checked) {
					input.checked = false
				}
				this.lastSectionOpened = ""
			} else {
				this.lastSectionOpened = section
			}
		},
        create_schema(FAQList) {
            let jsonld = '{ "@context": "https://schema.org", "@type": "FAQPage", "mainEntity": [';
            for (var i = 0; i < FAQList.length; i++) {
                if((i + 1) == FAQList.length){
                    jsonld += '{ "@type": "Question", "name": "' + this.FAQList[i].question +'" , "acceptedAnswer": { "@type": "Answer", "text": "' + this.FAQList[i].answer + '" }}';
                }else{
                    jsonld += '{ "@type": "Question", "name": "' + this.FAQList[i].question +'" , "acceptedAnswer": { "@type": "Answer", "text": "' + this.FAQList[i].answer + '"}},';
                }
            }
            jsonld += ']}';
            return jsonld;
        }
	},
	head(){
		return {
			title: "Student Loan Refinance Calculator",
			meta: [
				{hid: "ogmetatitle", property: 'og:title', content: "Student Loan Refinance Calculator"},
				{hid: "metadescription", name: 'description', content: "This student loan refinancing calculator estimates how much you could lower your total and monthly loan payments by refinancing your student loans."},
				{hid: "ogmetadescription", property: 'og:description', content: "This student loan refinancing calculator estimates how much you could lower your total and monthly loan payments by refinancing your student loans."},
				{
					hid: 'og-url',
					name: 'og:url',
					property: 'og:url',
					content: `${this.$store.state.config.sfcHost}/calculators/student-loan-refinance-calculator`
				},
				{
					hid: 'og-image',
					name: 'og:image',
					property: 'og:image',
					content: 'https://web-resources.savingforcollege.com/images/cost-of-deferment-calculator-thumbnail.jpg'
				},
			],
			link: [
 					{ hid: "canonical_url", rel: "canonical", href: "https://www.savingforcollege.com/calculators/student-loan-refinance-calculator"}
 				],
			__dangerouslyDisableSanitizers: ['title', 'meta']
		}
	},
	filters: {
		capText(value){
			if(value.length < 165) {
				return value
			}
			let paragraph = ""
			let i = 0
			const words = value.split(" ")
			while (paragraph.length < 165 && (paragraph.length + words[i].length < 165)) {
				paragraph += ` ${words[i]}`
				i++
			}
			return paragraph.trim() + "..."
		}
	}


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* I have included page specific styles to the card here, widths and classes specifically for this calculator the rest of the main styles can be found in the "styles.css" */
    .student-loan-widget-v1{
		background: white;
		padding-bottom: 40px;
	}
	.student-loan-widget-v1-inside{
		background: white;
		padding-bottom: 0;
		padding-top: 24px;
	}
	.no-mobile{
		display: block;
	}
	.mobile-and-tablet{
		display: none;
	}
	.related-content{
		padding-top: 40px;
	}
	.sfc-student-loan-calc .card__image img{
		height: 100%;
		object-fit: cover;
	}
	.sfc-student-loan-calc .card__image{
		height: 100%;
	}
	.ad-refinancecalc.mobile-and-tablet{
		display: none;
	}
	.ad-refinancecalc{
		width: 100%;
    	text-align: center;
		overflow: hidden;
	}
	.ad-refinancecalc-inside{
		width: 100%;
		padding: 0px;
    	text-align: center;
		overflow: hidden;
	}
	.ad-refinancecalc-bottom{
    	text-align: center;
    	padding-bottom: 40px;
		overflow: hidden;
	}
	.sfc-card {
        width: 90%;
        margin-top: 40px;
        margin-left: 4%;
    }
    .sfc-card .form {
        width: 100%;
        margin: 0px 0%;
    }
    .form .btn {
        margin-top: 56px;
    }
    .sfc-card.completed {
        width: 80%;
        margin-left: 5%;
    }
    .sfc-card.completed h5 {
        width: 50%;
    }
    .sfc-card.completed .form {
        width: 50%;
    }
    .results {
        width: 100%;
        border-radius: 0px;
    }
    .graybg {
        border-radius: 0px 0px 8px 8px;
	}
	/* table.list td {
    	width: 15%;
	} */

	table.list td{
		padding: 25px 15px;
		font-size: 14px;
		border-bottom: none;
		display: inline-block;
		width: inherit !important;
	}
	.list td.gray-text{
		width: 50%;
	}
	.list td.dark-text{
		width: 100%;
		text-align: left;
		padding: 8px 15px;
		font-size: 16px;
	}
	.list td.dark-text strong{
		text-align: right !important;
		float: right;
	}

	.after-repayment-total {
		font-size: 24px
	}

	.mediumText {
		font-size: 28px
	}

	.largerText {
		font-size: 40px
	}

	td > span {
		display: inline-block;
		margin-top: 9px;
	}

	.income-driven-results tbody tr:nth-child(odd){
		background: #1ca8fc;
		color: #fff;
	}

    @media only screen and (max-width: 1220px) {
        .sfc-card {
            width: 90%;
            margin-top: 40px;
            margin-left: 4%;
        }
        .sfc-card.completed {
            width: 100%;
            margin-left: 0%;
        }
    }

	@media (min-width: 768px) {
        .blue-box {
            height: 402px;
        }
    }

	.bluebg h2 {
		padding-bottom: 0px !important;
		border-bottom: 1px solid #0C3864;
		color: #fff;
	}

	.bluebg .subText {
		font-size: 12px;
		opacity: .8;
		margin: 2px 0px;
	}

    @media only screen and (max-width: 768px) {
		.mobile-and-tablet{
			display: block;
		}
		.no-mobile{
			display: none;
		}
		.ad-refinancecalc.mobile-and-tablet{
			display: block;
		}
		.ad-refinancecalc{
			padding-top: 0px;
			padding-bottom: 40px;
		}
        .sfc-card {
            width: 100%;
            margin-top: 40px;
            margin-left: 0%;
            display: inline-block;
        }
        .form .flex {
            display: inline-block !important;
        }
        .sfc-card.completed .form {
            width: 90%;
        }
        .sfc-card .form {
            width: 100%;
        }
        .bluebg {
            background: #125393;
            color: #fff;
            border-radius: 0px;
        }
	}
</style>
